<template>
  <v-container fluid>
    <MultiVariableLineChart title="Histórico de variables"></MultiVariableLineChart>
  </v-container>
</template>

<script>
import MultiVariableLineChart from "@/components/utils/MultiVariableLineChart.vue";

export default {
  name: "HistoryPage",

  components: {
    MultiVariableLineChart,
  },
};
</script>
